'use strict';

angular.module('portal.i18n')
    .controller('I18nSelectLanguageController', ['ShareCrfLanguageService', function(ShareCrfLanguageService) {
        var vm = this;

        vm.change = function(language) {
            ShareCrfLanguageService.setLanguage(language);
        };
    }]);
